var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.splitedList),function(item,index){return _c('div',{key:index},[_c('div',[_c('span',[_vm._v("\r\n            "+_vm._s(item)+" "),_c('br')])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }